import { styled } from "@mui/material/styles";
import { Grid, Button, IconButton } from "@mui/material";
import { opacity } from "html2canvas/dist/types/css/property-descriptors/opacity";

export const Container = styled(Grid)({
  display: "flex",
  gap: "10px",
  justifyContent: "end",
});

export const RemoveButton = styled(IconButton)(({ theme }) => ({
  opacity: 0.5,
  "&:hover": {
    opacity: 1,
  },
}));
